export const SUPPORTED_LANGUAGES = {
  EN: { locale: 'en', key: 'EN' },
  PT: { locale: 'pt', key: 'PT' },
  BR: { locale: 'pt-br', key: 'BR' },
};
